export type HighEntropyClientHints = {
  platform: string
  platformVersion: string
  architecture: string
  bitness: string
  model: string
  mobile: boolean
  fullVersionList: Array<{ brand: string; version: string }>
  wow64: boolean
}

type NavigatorUAData = {
  getHighEntropyValues: (hints: Array<string>) => Promise<HighEntropyClientHints>
}

type NavigatorWithUAData = Navigator & {
  userAgentData?: NavigatorUAData
}

const HIGH_ENTROPY_HINTS: Array<keyof HighEntropyClientHints> = [
  'platform',
  'platformVersion',
  'architecture',
  'bitness',
  'model',
  'mobile',
  'fullVersionList',
  'wow64',
]

export async function getHighEntropyClientHints(): Promise<HighEntropyClientHints | null> {
  const nav = typeof navigator !== 'undefined' ? (navigator as NavigatorWithUAData) : null
  if (!nav?.userAgentData?.getHighEntropyValues) {
    return null
  }
  try {
    return await nav.userAgentData.getHighEntropyValues(HIGH_ENTROPY_HINTS)
  } catch {
    return null
  }
}
